import React, { useState } from "react";
import DeltaBadge from "./DeltaBadge";

const SortIcon = ({ col, sortCol, sortDir }) => {
  const active = sortCol === col;
  return (
    <span style={{ display: "inline-flex", flexDirection: "column", marginLeft: "4px", verticalAlign: "middle" }}>
      <span style={{ fontSize: "8px", lineHeight: 1, color: active && sortDir === "asc"  ? "#2563EB" : "#D1D5DB" }}>▲</span>
      <span style={{ fontSize: "8px", lineHeight: 1, color: active && sortDir === "desc" ? "#2563EB" : "#D1D5DB" }}>▼</span>
    </span>
  );
};

const CrewTable = ({ crewBreakdown = [], currency = "AED", crewLabel = "Crew" }) => {
  const COLS = [
    { key: "jobs",    label: "Jobs",                    prevKey: "prevJobs" },
    { key: "revenue", label: `Revenue (${currency})`,   prevKey: "prevRevenue" },
  ];
  const [sortCol, setSortCol] = useState("revenue");
  const [sortDir, setSortDir] = useState("desc");
  const [filter, setFilter] = useState("");

  const filtered = filter ? crewBreakdown.filter(c => c.crew_id === filter) : crewBreakdown;

  const sorted = [...filtered].sort((a, b) => {
    const av = a[sortCol] ?? 0;
    const bv = b[sortCol] ?? 0;
    return sortDir === "asc" ? av - bv : bv - av;
  });

  const handleSort = (col) => {
    setSortDir(sortCol === col ? (sortDir === "asc" ? "desc" : "asc") : "desc");
    setSortCol(col);
  };

  const thStyle = {
    background: "#F9FAFB", fontWeight: "600", fontSize: "13px", color: "#374151",
    padding: "10px 14px", borderBottom: "1px solid #E5E7EB", whiteSpace: "nowrap",
    userSelect: "none", cursor: "pointer",
  };
  const tdStyle = {
    padding: "10px 14px", fontSize: "13px", color: "#374151",
    borderBottom: "1px solid #F3F4F6", verticalAlign: "middle",
  };

  return (
    <div>
      {crewBreakdown.length > 1 && (
        <div style={{ marginBottom: "12px" }}>
          <select
            value={filter}
            onChange={e => setFilter(e.target.value)}
            style={{ border: "1px solid #E5E7EB", borderRadius: "6px", padding: "6px 10px", fontSize: "13px", color: "#374151" }}
          >
            <option value="">All {crewLabel}</option>
            {crewBreakdown.map(c => (
              <option key={c.crew_id} value={c.crew_id}>{c.crew_name}</option>
            ))}
          </select>
        </div>
      )}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ ...thStyle, cursor: "default" }}>{crewLabel}</th>
              {COLS.map(c => (
                <th key={c.key} style={thStyle} onClick={() => handleSort(c.key)}>
                  {c.label} <SortIcon col={c.key} sortCol={sortCol} sortDir={sortDir} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ ...tdStyle, textAlign: "center", color: "#9CA3AF", padding: "32px" }}>
                  No {crewLabel.toLowerCase()} data
                </td>
              </tr>
            ) : sorted.map(crew => (
              <tr
                key={crew.crew_id}
                onMouseEnter={e => e.currentTarget.style.background = "#F9FAFB"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                style={{ transition: "background 0.15s" }}
              >
                <td style={{ ...tdStyle, fontWeight: "600", color: "#111827" }}>{crew.crew_name}</td>
                {COLS.map(c => (
                  <td key={c.key} style={tdStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span>
                        {c.key === "revenue"
                          ? `${currency} ${(crew.revenue ?? 0).toLocaleString()}`
                          : crew[c.key] ?? "—"}
                      </span>
                      <DeltaBadge current={crew[c.key] ?? 0} previous={crew[c.prevKey] ?? 0} />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CrewTable;
